import { anyTemplate, AnyCollection } from "./Any";
import { universalTemplate, UniversalCollection } from "./Universal";
import { authTemplate, AuthCollection } from "./Auth";
import { UniversalReadCollection, UniversalReadTemplate } from "./UniversalRead";
export const templateMap = {
  list: universalTemplate,
  form: universalTemplate,
  any: anyTemplate,
  universal: universalTemplate,
  universal_read: UniversalReadTemplate,
  auth: authTemplate
};
export function getTemplate(type) {
  return templateMap[type];
}
export const collectCtorMap = {
  list: UniversalCollection,
  form: UniversalCollection,
  any: AnyCollection,
  universal: UniversalCollection,
  universal_read: UniversalReadCollection,
  auth: AuthCollection
};
export function getCollectionCtor(type) {
  return collectCtorMap[type];
}
//# sourceMappingURL=index.js.map
